import { useMatchMedia } from "./use-match-media";

export function usePrefersReducedMotion() {
  const motionOk = useMatchMedia("(prefers-reduced-motion: no-preference)");
  return !motionOk;
}
